module.exports = __webpack_public_path__ + "img/1-6.eebbb419.png";